import {PolicyJsonModel, PolicySchema} from "../../domain/cra/CraDomains";
import {ReduxBaseAction} from "../../domain/redux/ReduxBaseAction";
import {ComponentDependency} from "../../domain/ui/ComponentMetadata";


export type PolicyActions = "CHANGE_POLICY" |
  "CHANGE_POLICY_IS_UPDATE" |
  "CLEAR_POLICY" |
  "CHANGE_POLICY_SCHEMA" |
  "CHANGE_POLICY_DEPENDENCIES" |
  "CHANGE_POLICY_DIRTY"

export const changePolicy = (payload: PolicyJsonModel) => ({
  type: "CHANGE_POLICY",
  payload
}) as ReduxBaseAction<PolicyJsonModel | null, PolicyActions>

export const changePolicySchema = (payload: PolicySchema | null) => ({
  type: "CHANGE_POLICY_SCHEMA",
  payload
}) as ReduxBaseAction<PolicySchema | null, PolicyActions>

export const changePolicyIsUpdate = (payload: boolean) => ({
  type: "CHANGE_POLICY_IS_UPDATE",
  payload
}) as ReduxBaseAction<boolean | null, PolicyActions>

export const clearPolicy = () => ({
  type: "CLEAR_POLICY",
  payload: void 0
}) as ReduxBaseAction<any, PolicyActions>

export const changePolicyDependencies = (payload: ComponentDependency[]) => ({
  type: "CHANGE_POLICY_DEPENDENCIES",
  payload
}) as ReduxBaseAction<ComponentDependency[], PolicyActions>

export const changePolicyDirty = (payload: boolean) => ({
  type: "CHANGE_POLICY_DIRTY",
  payload
}) as ReduxBaseAction<boolean, PolicyActions>
